// src/context/ThemeContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

const THEME_KEY = 'theme'; // 'light' | 'dark' | 'system'

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'system');

  useEffect(() => {
    const root = document.documentElement;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = (mode) => {
      const isDark = mode === 'dark' || (mode === 'system' && mq.matches);
      root.classList.toggle('dark', isDark);
    };

    apply(theme);

    const onChange = () => theme === 'system' && apply('system');
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, [theme]);

  const value = {
    theme,
    setTheme: (next) => {
      localStorage.setItem(THEME_KEY, next);
      setTheme(next);
    },
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
